import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import { getPrioritiesApi } from 'api/priorities';
import { RequestQueryKeysE, RequestStaleTimeE } from 'declarations/enums/react-query';
import type { ApiErrorI } from 'declarations/interfaces/errors';
import type { TicketPriorityI } from 'declarations/interfaces/ticketPriorities';

export const useFetchTicketPriorities = (
  isEnabled: boolean
): UseQueryResult<TicketPriorityI[], ApiErrorI> =>
  useQuery<TicketPriorityI[], ApiErrorI>(
    [RequestQueryKeysE.FetchPriorities],
    (): Promise<TicketPriorityI[]> => getPrioritiesApi(),
    { enabled: isEnabled, staleTime: RequestStaleTimeE.ClaimStatuses }
  );
